exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-container{position:relative;height:100vh;overflow:hidden}.slide-list{position:relative}.slide-item{position:absolute;width:100%;height:100%;z-index:0}\n", ""]);

// exports
exports.locals = {
	"slide-container": "slide-container",
	"slideContainer": "slide-container",
	"slide-list": "slide-list",
	"slideList": "slide-list",
	"slide-item": "slide-item",
	"slideItem": "slide-item"
};